import { render, staticRenderFns } from "./SelectAndBandTraverPointToResidence.vue?vue&type=template&id=3aa4539d"
import script from "./SelectAndBandTraverPointToResidence.vue?vue&type=script&lang=js"
export * from "./SelectAndBandTraverPointToResidence.vue?vue&type=script&lang=js"
import style0 from "./SelectAndBandTraverPointToResidence.vue?vue&type=style&index=0&id=3aa4539d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports